import { render, staticRenderFns } from "./MtSuppliersList.vue?vue&type=template&id=3d757974&scoped=true&"
import script from "./MtSuppliersList.vue?vue&type=script&lang=js&"
export * from "./MtSuppliersList.vue?vue&type=script&lang=js&"
import style0 from "./MtSuppliersList.vue?vue&type=style&index=0&id=3d757974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d757974",
  null
  
)

export default component.exports